

















import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import AgentForm from "@/components/agent/AgentForm.vue";
import { agentApi } from "@/getinfo-api";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

@Component({
  components: { AgentForm, CPage }
})
export default class AgentCreate extends Vue {
  isLoading: boolean = false;

  get breadcrumbs() {
    return [
      {
        to: { name: "agents" },
        label: i18n.tc(LocalesFields.Agents)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }

  async saveHandler(agent: IAgent) {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Agent.createAgent(agent);
      await this.$router.push({ name: "agentView", params: { id: data.id! } });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  cancelHandler() {
    this.$router.push({ name: "agents" });
  }
}
